module.exports = __webpack_public_path__ + "img/客户icon_3.5908dbc3.png";